(function () {
  /* --- Guven rozetleri --- */
  function insertBadges() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.getElementById('pv-trust')) return;
    var atc = document.querySelector('.atc-button, .product-form__submit');
    var anchor = atc && (atc.closest('.product-form') || atc.parentElement);
    if (!anchor || !anchor.parentNode) return;
    var items = [['🔒', 'Güvenli Ödeme'], ['🔄', '14 Gün İade'], ['🚚', 'Hızlı Kargo'], ['💳', 'Taksit İmkanı']];
    var box = document.createElement('div');
    box.id = 'pv-trust';
    box.innerHTML = items.map(function (i) { return '<div class="pv-trust-item"><span>' + i[0] + '</span>' + i[1] + '</div>'; }).join('');
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
  }

  /* --- Ucretsiz kargo cubugu (sepet) — TEK bar --- */
  var THRESH = 150000;
  function tl(c) { return Math.round(c / 100).toLocaleString('tr-TR'); }
  function renderBar(el, cart) {
    if (!cart || cart.item_count === 0) { el.style.display = 'none'; return; }
    el.style.display = 'block';
    var sub = cart.total_price;
    var rem = THRESH - sub;
    var pct = Math.max(4, Math.min(100, Math.round(sub / THRESH * 100)));
    var msg = rem > 0 ? ('Ücretsiz kargoya <b>' + tl(rem) + ' TL</b> kaldı!') : 'Tebrikler, kargonuz <b>ÜCRETSİZ</b> 🎉';
    el.innerHTML = '<div class="pv-fs-msg">' + msg + '</div><div class="pv-fs-track"><div class="pv-fs-fill" style="width:' + pct + '%"></div></div>';
  }
  function fsBar() {
    var all = Array.prototype.slice.call(document.querySelectorAll('.cart-drawer__footer, .drawer__footer, .cart__footer, #main-cart-footer'));
    var anchor = null;
    for (var i = 0; i < all.length; i++) { if (all[i].offsetParent !== null) { anchor = all[i]; break; } }
    if (!anchor && all.length) anchor = all[0];
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var bars = document.querySelectorAll('.pv-fs');
      for (var j = 0; j < bars.length; j++) { if (!anchor || bars[j].parentElement !== anchor) bars[j].parentNode.removeChild(bars[j]); }
      if (!anchor) return;
      var bar = anchor.querySelector(':scope > .pv-fs');
      if (!bar) { bar = document.createElement('div'); bar.className = 'pv-fs'; anchor.insertBefore(bar, anchor.firstChild); }
      renderBar(bar, cart);
    }).catch(function () {});
  }
  function watchCart() {
    var cd = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer, cart-notification');
    if (cd && !cd.__pvWatched) {
      cd.__pvWatched = true;
      new MutationObserver(function () { clearTimeout(window.__pvfsT); window.__pvfsT = setTimeout(fsBar, 250); }).observe(cd, { childList: true, subtree: true });
    }
  }

  /* --- Marka SEO schema --- */
  function orgSchema() {
    if (document.getElementById('pv-org-ld')) return;
    var org = { '@context': 'https://schema.org', '@type': 'Store', name: 'PrintivaTR', url: location.origin, description: 'Mürekkepsiz mini termal yazıcı ve termal rulolar.', currenciesAccepted: 'TRY', areaServed: 'TR' };
    var s = document.createElement('script'); s.type = 'application/ld+json'; s.id = 'pv-org-ld'; s.textContent = JSON.stringify(org); document.head.appendChild(s);
  }

  function run() { insertBadges(); orgSchema(); fsBar(); watchCart(); }
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  setTimeout(run, 1500);
})();
